import React, {useEffect, useRef, useState} from 'react';
import axios from "../../services/axiosInstance";
import maCateImg from "../../assets/img/m-a-cate.png";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";

function AdminErrorLogPg() {

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    // 날짜 포맷 함수
    const formatDateString = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // ✅ 초기 렌더링 시: 오늘 기준으로 endDate, startDate 설정
    useEffect(() => {
        const today = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(today.getMonth() - 3);

        setEndDate(formatDateString(today));
        setStartDate(formatDateString(threeMonthsAgo));
    }, []);

    // ✅ endDate 변경 시마다: 해당 날짜 기준으로 startDate 재설정
    useEffect(() => {
        if (!endDate) return;

        const newEndDate = new Date(endDate);
        const newStartDate = new Date(newEndDate);
        newStartDate.setMonth(newEndDate.getMonth() - 3);

        setStartDate(formatDateString(newStartDate));
    }, [endDate]);

    const startHandle = (e) => {
        setStartDate(e.target.value);
    };

    const endHandle = (e) => {
        setEndDate(e.target.value);
    };

    useEffect(() => {
        if (startDate && endDate) {
            findErrorLog();
        }
    }, [startDate, endDate]);

    const formattedStartDate = startDate.replace(/-/g, '');
    const formattedEndDate = endDate.replace(/-/g, '');

    const [data, setData] = useState([]);
    const findErrorLog = (() => {
        try {
            axios({
                method: 'get',
                url: '/errorlog/findErrorLog',
                params: {
                    startDate: formattedStartDate,
                    endDate: formattedEndDate
                }
            })
                .then((response) => {
                    const data = response.data || [];
                    setData(data.sort((a, b) => b.seqNum - a.seqNum));
                })
        } catch (error) {
            console.log("오류로그 조회실패");
            setData([]);
        }
    })





    return (
        <div className="AdminPageSetPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">오류로그현황</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card">
                    <div className="pg-set-tab-content font-t-cont">
                            <div className="banner-info-container">
                                <div className="admin-wrap-card">

                                    {/*날짜 & 데이터조회 버튼영역*/}
                                    <div className="display-flex align-center m-b-30">
                                        <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle}
                                                       endHandle={endHandle}/>
                                    </div>

                                    {/* 오류로그 데이터 리스트 컨테이너 */}
                                        <div>
                                            <div className="modal-body2">
                                                <div className="table-container">
                                                    <table className="tax-table">
                                                        <thead>
                                                        <tr>
                                                            <th style={{width: '15%'}}>ID</th>
                                                            <th style={{width: '25%'}}>Title</th>
                                                            <th style={{width: '45%'}}>Content</th>
                                                            <th style={{width: '15%'}}>Time</th>
                                                        </tr>
                                                        </thead>
                                                        {/* ✅ 수정된 부분: tbody에서 클래스 제거 */}
                                                        <tbody>
                                                        {data && data.map((log, index) => (
                                                            <tr key={log.seqNum || index}>
                                                                <td>{log.email}</td>
                                                                <td>{log.title}</td>
                                                                <td>{log.content}</td>
                                                                <td>{log.regTime}</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>



                                </div>
                            </div>



                    </div>


                </div>
            </div>

        </div>
    )
}

export default AdminErrorLogPg